/*
  BODITONIC — Formula Page Interactivity
  Handles: size selection, one-time vs subscribe toggle, cadence reveal,
  live price update, and sticky add-to-cart bar on scroll.

  NOTE: This assumes standard Shopify /cart/add.js AJAX cart behavior via the
  theme's existing cart handling. If your theme uses a custom cart drawer JS
  module, hook the form submit into that instead of relying on default form action.
*/

document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('formula-purchase-form');
  if (!form) return;

  const sizeInputs = form.querySelectorAll('input[name="formula-size"]');
  const purchaseTypeInputs = form.querySelectorAll('input[name="purchase_type"]');
  const cadenceBlock = form.querySelector('.formula-cadence');
  const variantIdField = document.getElementById('formula-variant-id');
  const currentPriceEl = document.getElementById('formula-current-price');
  const stickyPriceEl = document.getElementById('formula-sticky-price');
  const sellingPlanSelect = form.querySelector('select[name="selling_plan"]');
  const heroImage = document.getElementById('formula-hero-image');

  const SUBSCRIBE_DISCOUNT = 0.15;

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updatePrice() {
    const selectedSize = form.querySelector('input[name="formula-size"]:checked');
    const isSubscribing = form.querySelector('input[name="purchase_type"]:checked')?.value === 'subscribe';
    if (!selectedSize) return;

    let price = parseInt(selectedSize.dataset.price, 10);
    if (isSubscribing) {
      price = Math.round(price * (1 - SUBSCRIBE_DISCOUNT));
    }

    const fullPrice = parseInt(selectedSize.dataset.price, 10);
    const compareEl = document.getElementById('formula-compare-price');
    if (compareEl) {
      compareEl.textContent = formatMoney(fullPrice);
      compareEl.hidden = !isSubscribing;
    }
    const oneTimeSub = document.getElementById('formula-onetime-price');
    if (oneTimeSub) oneTimeSub.textContent = formatMoney(fullPrice);
    const subscribeSub = document.getElementById('formula-subscribe-price');
    if (subscribeSub) subscribeSub.textContent = formatMoney(Math.round(fullPrice * (1 - SUBSCRIBE_DISCOUNT))) + ' per delivery';


    if (currentPriceEl) currentPriceEl.textContent = formatMoney(price);
    if (stickyPriceEl) stickyPriceEl.textContent = formatMoney(price);
    if (variantIdField) variantIdField.value = selectedSize.value;
  }

  function updateImage() {
    const selectedSize = form.querySelector('input[name="formula-size"]:checked');
    if (!heroImage || !selectedSize) return;
    const newSrc = selectedSize.dataset.image;
    if (!newSrc) return;
    heroImage.src = newSrc;
    if (selectedSize.dataset.imageSrcset) heroImage.srcset = selectedSize.dataset.imageSrcset;
    if (selectedSize.dataset.imageAlt) heroImage.alt = selectedSize.dataset.imageAlt;
  }

  // Size pill selection styling + price update
  sizeInputs.forEach((input) => {
    input.addEventListener('change', () => {
      form.querySelectorAll('.formula-pill').forEach((pill) => pill.classList.remove('is-selected'));
      input.closest('.formula-pill').classList.add('is-selected');
      updatePrice();
      updateImage();
    });
  });

  // One-time vs Subscribe toggle
  purchaseTypeInputs.forEach((input) => {
    input.addEventListener('change', () => {
      form.querySelectorAll('.formula-toggle-option').forEach((opt) => opt.classList.remove('is-selected'));
      input.closest('.formula-toggle-option').classList.add('is-selected');

      const subscribing = input.value === 'subscribe';
      if (cadenceBlock) cadenceBlock.hidden = !subscribing;

      // Remove selling_plan from submission entirely when one-time is selected,
      // so Shopify treats it as a standard one-time purchase.
      if (sellingPlanSelect) {
        sellingPlanSelect.disabled = !subscribing;
      }

      updatePrice();
    });
  });

  // Sticky bar: show once the primary add-to-cart button scrolls out of view
  const stickyBar = document.getElementById('formula-sticky-bar');
  const primaryButton = form.querySelector('.formula-add-to-cart');

  if (stickyBar && primaryButton && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      ([entry]) => {
        stickyBar.hidden = entry.isIntersecting;
      },
      { threshold: 0 }
    );
    observer.observe(primaryButton);
  }

  // Only submit a selling plan when "Subscribe" is chosen
  if (sellingPlanSelect) {
    const checkedType = form.querySelector('input[name="purchase_type"]:checked');
    sellingPlanSelect.disabled = !(checkedType && checkedType.value === 'subscribe');
  }


  updatePrice();
  updateImage();
});
